import { ReactNode, type JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import {
    Heading,
    PointerLightIcon,
    Text,
    TextLinkProps,
    ButtonOrLink,
} from '../../../atoms';
import type { CommonProps } from '../../../types';

export interface SpaceCardProps
    extends CommonProps,
        VariantProps<typeof SpaceCardStyles> {
    image?: ReactNode;
    title: string;
    location?: string;
    venue: string;
    onCardClick?: () => void;
    linkProps: Pick<TextLinkProps, 'href' | 'locale'>;
}

export const SpaceCardStyles = tv({
    slots: {
        root: 'relative click-area group',
    },
});

export const SpaceCard = ({
    className,
    testId = 'space-card',
    image,
    title,
    location,
    venue,
    linkProps,
    onCardClick,
    ...props
}: SpaceCardProps): JSX.Element => {
    const { root } = SpaceCardStyles();

    return (
        <div className={root({ className })} {...props} data-testid={testId}>
            <div className="mb-3 aspect-video overflow-hidden rounded-md">
                <div className="transition group-hover:scale-105">{image}</div>
            </div>
            <ButtonOrLink
                className="click-area-link"
                enableDrag={false}
                {...(onCardClick ? { onClick: onCardClick } : undefined)}
                {...linkProps}
            >
                <Heading as="h2" className="mb-0" size="h4">
                    {title}
                </Heading>
            </ButtonOrLink>
            <div className="flex items-start justify-between">
                <Text className="flex items-center gap-2">
                    <PointerLightIcon size="sm" />
                    {location}
                </Text>

                <Text className="text-right">{venue}</Text>
            </div>
        </div>
    );
};
